import * as React from "react";
import { connect } from "react-redux";
import Notifications from "react-notification-system-redux";
import { Notification } from "react-notification-system";

type NotificationOverlayProps = {
  notifications: Notification[];
};

/** NotificationOverlay component that renders the notifications */
export class NotificationOverlay extends React.Component<NotificationOverlayProps> {
  render(): JSX.Element {
    const { notifications } = this.props;
    const grayShadow = "0 0 10px rgba(128, 128, 128, 0.9)";
    const style = {
      NotificationItem: {
        // Override the notification item
        DefaultStyle: {
          margin: "10px 5px 2px 1px",
          color: "black",
          backgroundColor: "white",
          borderTop: "0px",
          WebkitBoxShadow: grayShadow,
          MozBoxShadow: grayShadow,
          boxShadow: grayShadow
        },

        success: {
          borderLeft: "8px solid #5ea400"
        },
        info: {
          borderLeft: "8px solid #0071B9"
        },
        warning: {
          borderLeft: "8px solid #FFC500"
        },
        error: {
          borderLeft: "8px solid #C71F25"
        }
      },
      Dismiss: {
        DefaultStyle: {
          fontSize: "0px",
          width: "0px",
          height: "0px"
        }
      }
    };
    return <Notifications notifications={notifications} style={style} allowHTML={true} />;
  }
}

const mapStateToProps = (state: State.Root) => ({
  notifications: state.notifications
});

export default connect(mapStateToProps, {})(NotificationOverlay);
